// Resolves a token's symbol + decimals from its address/chainId (via the same
// assetInfo service the rest of the app uses). The private activity rows need
// this because RAILGUN history items carry only raw amounts + token addresses.
import { useEffect, useState } from 'react'

import { Network } from '@ambire-common/interfaces/network'
import { resolveAssetInfo } from '@ambire-common/services/assetInfo'
import useNetworksControllerState from '@web/hooks/useNetworksControllerState'

export const useResolvedToken = (address?: string, chainId?: bigint) => {
  const { networks } = useNetworksControllerState()
  const [info, setInfo] = useState<{ symbol?: string; decimals?: number }>({})

  useEffect(() => {
    if (!address || !chainId) {
      setInfo({})
      return
    }
    const network = networks.find((n: Network) => n.chainId === chainId)
    if (!network) {
      setInfo({})
      return
    }
    resolveAssetInfo(address, network, ({ tokenInfo }) => {
      if (tokenInfo) setInfo({ symbol: tokenInfo.symbol, decimals: tokenInfo.decimals })
    }).catch(() => setInfo({}))
  }, [address, chainId, networks])

  return info
}

export default useResolvedToken
